<template>
  <div>
    <v-dialog v-model="rejectReasonModal" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Reason for Rejection
        </v-card-title>
        <v-card-text>
          <v-form ref="rejectReasonForm" lazy-validation>
            <v-text-field
              v-model="rejectReason"
              :rules="[(v) => !!v || 'Reason is required']"
              label="Reason *"
              required
            ></v-text-field>
            <v-radio-group
              v-model="selectedRejectSuggestion"
              @change="rejectReason = selectedRejectSuggestion"
            >
              <v-radio
                v-for="(suggestion, index) in rejectSuggestions"
                :key="index"
                :label="suggestion"
                :value="suggestion"
              ></v-radio>
            </v-radio-group>
            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="disabled"
                color="primary"
                flat
                @click="rejectItem(editedItem)"
              >
                Confirm
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="commentModal" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Comment for Disbursement
        </v-card-title>
        <v-card-text>
          <v-form ref="commentForm" lazy-validation>
            <v-text-field
              v-model="comment"
              label="Comment"
              required
            ></v-text-field>
            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="disabled"
                color="primary"
                flat
                @click="disburseItem(editedItem)"
              >
                Confirm
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <FunndingActionsResponseDialog
      :results="results"
      v-model="responseDialog"
      :stop="stop"
      @stopAction="stop = true"
      :total="applications.length"
    />

    <v-list class="mt-2 text-left">
      <!-- <h2 class="ml-3">Actions</h2>
      <v-divider></v-divider>
      <br /> -->
      <v-btn
        small
        :disabled="disabled"
        v-if="status == 1"
        color="success"
        @click="verifyItem"
      >
        Verify
      </v-btn>
      <v-btn
        small
        :disabled="disabled"
        v-if="status == 1"
        color="error"
        @click="rejectReasonModal = true"
      >
        Reject
      </v-btn>
      <v-btn
        small
        :disabled="disabled"
        v-if="status == 3"
        color="success"
        title="Change status to Pending"
        @click="rejectToPending"
      >
        Bring to Pending
      </v-btn>
      <v-btn
        small
        :disabled="disabled"
        v-if="status == 4"
        color="success"
        title="Change status to Verified"
        @click="backToVerify"
      >
        Back to Verified
      </v-btn>
      <v-btn
        small
        :disabled="disabled"
        v-if="status == 5"
        color="success"
        title="Change status to Signed by Investee"
        @click="bringToSignedByInvestee"
      >
        Bring to Signed by Investee
      </v-btn>
      <v-btn
        small
        :disabled="disabled"
        v-if="status == 6"
        color="success"
        @click="approveItem"
      >
        Approve
      </v-btn>
      <v-btn
        small
        :disabled="disabled"
        v-if="status == 7"
        color="success"
        @click="commentModal = true"
      >
        Disburse
      </v-btn>
      <v-btn
        small
        :disabled="disabled"
        v-if="status < 8"
        color="warning"
        title="Change status to Cancel"
        @click="cancelStatus"
      >
        Bring to Cancelled
      </v-btn>
    </v-list>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import HTTP from "@/utils/HTTP";
  import {
    cancelUrl,
    verifyUrl,
    rejectUrl,
    rejectToPendingUrl,
    processingToVerifyUrl,
    approveUrl,
    disburseUrl,
    bringToSignedByInvesteeUrl,
  } from "@/utils/variables";
  import FunndingActionsResponseDialog from "@/components/Dialogs/FunndingActionsResponseDialog";

  export default {
    props: ["status", "applications"],
    components: {
      FunndingActionsResponseDialog,
    },
    data() {
      return {
        stop: false,
        disabled: false,
        selectedRejectSuggestion: "",
        responseDialog: false,
        results: [],
        rejectSuggestions: [
          "Missing information or paperwork",
          "High debt-income ratio",
          "Document verification failed",
          "Bad credit history",
          "Unstable employment history",
          "Minimum income requirement not met",
        ],
        rejectReasonModal: false,
        commentModal: false,
        rejectReason: "",
        comment: "",
      };
    },
    computed: {
      ...mapGetters(["indexData"]),
    },
    watch: {
      responseDialog() {
        if (this.responseDialog == false) {
          this.$emit("refetch");
        }
      },
    },
    methods: {
      async cancelStatus() {
        this.runAction(
          cancelUrl,
          "Are you sure you want to change all these applications' status to Cancel?"
        );
      },

      async verifyItem() {
        this.runAction(
          verifyUrl,
          "Are you sure you want to verify all these applications?"
        );
      },

      async rejectItem() {
        this.runAction(
          rejectUrl,
          "Are you sure you want to reject all these applications?",
          this.rejectReason
        );
      },

      async rejectToPending() {
        this.runAction(
          rejectToPendingUrl,
          "Are you sure you want to change all these applications' status to Pending?"
        );
      },

      async backToVerify() {
        this.runAction(
          processingToVerifyUrl,
          "Are you sure you want to change all these applications' status to Verified?"
        );
      },

      async approveItem() {
        this.runAction(
          approveUrl,
          "Are you sure you want to approve all these applications?"
        );
      },

      async disburseItem() {
        this.runAction(
          disburseUrl,
          "Are you sure you want to disburse all these applications?",
          "",
          this.comment
        );
      },

      async bringToSignedByInvestee() {
        this.runAction(
          bringToSignedByInvesteeUrl,
          "Are you sure you want to change all these applications' status to Signed by Investee?"
        );
      },

      async runAction(url, message, reason = "", comment = "") {
        var popUpMsg = confirm(message);

        if (popUpMsg) {
          this.rejectReasonModal = false;
          this.stop = false;
          this.disabled = true;
          this.responseDialog = true;
          this.results = [];
          for (let application of this.applications.sort(
            (a, b) => a.id - b.id
          )) {
            if (this.stop) {
              break;
            }
            application.loading = true;
            this.results = this.results;
            this.results.unshift(application);

            // Delay 1 second before every request
            await new Promise((resolve) => setTimeout(resolve, 1000));

            try {
              let { data } = await HTTP().get(
                `${url}/${application.id}?reason=${reason}&comment=${comment}`
              );

              this.newResults = [...this.results];

              this.newResults[0] = {
                ...this.newResults[0],
                error: data.error,
                errorMsg: data.errorMsg,
                loading: false,
                errorStatusMsg: data.error ? "Error" : "Success",
              };

              this.results = this.newResults;
            } catch (error) {
              this.newResults = [...this.results];

              this.newResults[0] = {
                ...this.newResults[0],
                error: 1,
                errorMsg: "Something wrong happened",
                loading: false,
                errorStatusMsg: "Failed",
              };
              this.results = this.newResults;
            }
          }
          this.stop = true;
          this.disabled = false;
        }
      },
    },
  };
</script>
